export function parseDateOnly(input: unknown): Date | null {
    if (!input) return null;
    if (input instanceof Date && !Number.isNaN(input.getTime())) {
        return new Date(input.getFullYear(), input.getMonth(), input.getDate());
    }
    if (typeof input === 'string') {
        const match = input.match(/^(\d{4})-(\d{2})-(\d{2})/);
        const hasValidFormat = input.length === 10 || !Number.isNaN(new Date(input).getTime());
        if (match && hasValidFormat) {
            const year = Number(match[1]);
            const monthIndex = Number(match[2]) - 1;
            const day = Number(match[3]);
            const result = new Date(year, monthIndex, day);
            if (result.getFullYear() !== year || result.getMonth() !== monthIndex || result.getDate() !== day) {
                return null;
            }
            return result;
        }
        const parsed = new Date(input);
        if (!Number.isNaN(parsed.getTime())) {
            return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
        }
    }
    return null;
}

export function formatDateOnly(input: unknown): string | undefined {
    if (!(input instanceof Date) || Number.isNaN(input.getTime())) {
        return undefined;
    }
    const year = input.getFullYear();
    const month = String(input.getMonth() + 1).padStart(2, '0');
    const day = String(input.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function formatDateOnlyAtUtcNoon(input: unknown): string | undefined {
    const dateOnly = formatDateOnly(input);
    return dateOnly ? `${dateOnly}T12:00:00.000Z` : undefined;
}

export function withSerializedDates<T extends object>(
    data: T,
    dateFields: (keyof T)[],
): Record<string, unknown> {
    const result = { ...(data as Record<string, unknown>) };
    for (const field of dateFields) {
        result[field as string] = formatDateOnly(result[field as string] as Date | null | undefined);
    }
    return result;
}
